import * as icon from '@campoint/odi-ui-icons';
import {
  Button,
  HStack,
  Heading,
  Icon,
  IconProps,
  ModalFooter,
  ModalHeader,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import {
  ResponsiveModalBodyBox,
  ResponsiveModalCloseButton,
  ResponsiveModalContent,
} from '../../../../../components/Layout/ResponsiveModal';
import { HelpcenterLink } from './HelpcenterLink/HelpcenterLink';

const ErrorIcon: React.FC<IconProps> = (props) => (
  <Icon as={icon.Error} boxSize={'icon.md'} color={'error.500'} {...props} />
);
export const ErrorModalContent: React.FC<{
  buttonLabel: string;
  onClick: () => void;
  text: React.ReactNode;
  heading: React.ReactNode;
}> = ({ buttonLabel, onClick, heading, text }) => {
  return (
    <ResponsiveModalContent minH={'526px'} maxW={'567px'}>
      <ModalHeader minH={'72px'}>
        <ResponsiveModalCloseButton />
      </ModalHeader>
      <ResponsiveModalBodyBox m={4}>
        <VStack alignItems={'stretch'} spacing={'22px'}>
          <HStack alignItems={'baseline'}>
            <ErrorIcon />
            <Heading size={'2xl'}>{heading}</Heading>
          </HStack>
          <Text>{text}</Text>
          <HelpcenterLink />
        </VStack>
      </ResponsiveModalBodyBox>
      <ModalFooter py={'8'} m={4}>
        <Button w={'full'} children={buttonLabel} onClick={onClick} />
      </ModalFooter>
    </ResponsiveModalContent>
  );
};
